module.exports = __webpack_public_path__ + "img/il.ab7fe958.jpg";